const { formatMoney } = window.BAO.Utils

class YotpoCustomerDetails extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    /*
     * Swell (Yotpo) API will use window.jQuery to dispatch events if it is available.
     * This appears to have a compatibility issue with document.addEventLister.
     */
    if (typeof window.jQuery === 'undefined') {
      document.addEventListener('swell:setup', () => {
        this.handleCustomerDetails()
      })
    } else {
      window.jQuery(document).on('swell:setup', () => {
        this.handleCustomerDetails()
      })
    }
  }

  handleCustomerDetails () {
    this.swellAPI = window.swellAPI
    this.swellConfig = window.swellConfig

    if (!this.swellAPI || !this.swellConfig) return

    this.customerDetails = this.swellAPI.getCustomerDetails()

    const customerPointsBalance = this.customerDetails.pointsBalance
    const latestRewardValue = this.getRewardValue()
    const pointsExpirationDate = this.getPointsExpirationDate()

    const allRedemptionOptions = this.swellAPI.getActiveRedemptionOptions()

    if (this.els?.points?.element) {
      this.els.points.element.textContent = `${customerPointsBalance}`
    }

    if (this.els.pointsExpiryDate?.element && pointsExpirationDate) {
      this.els.pointsExpiryDate.element.textContent = pointsExpirationDate.toLocaleDateString()
    }

    if (this.els?.pointsExpiry?.element && customerPointsBalance > 0) {
      this.els.pointsExpiry.element.style.display = 'flex'
    } else if (this.els?.pointsExpiry?.element) {
      this.els.pointsNegative.element.style.display = 'flex'
    }

    if (this.els?.currentRewards?.element) {
      let moneyFormat = window.theme.moneyFormat
      if (moneyFormat.indexOf('amount_no_decimals') === -1) {
        moneyFormat = moneyFormat.replace('amount', 'amount_no_decimals')
      }
      this.els.currentRewards.element.textContent = `${formatMoney(
        latestRewardValue,
        moneyFormat,
      )}`
    }

    if (latestRewardValue === 0) {
      this.els.nextPointsMessage.element.style.display = 'block'
    } else {
      this.els.redeemMessage.element.style.display = 'block'
    }

    if (latestRewardValue >= 5000) {
      this.els.limitMessage.element.style.display = 'block'
    }

    if (this.els?.nextPoints?.element) {
      let nextPoints = null
      allRedemptionOptions.forEach(option => {
        if (nextPoints !== null) return

        if (customerPointsBalance <= option.costInPoints) {
          nextPoints = option.costInPoints - customerPointsBalance
        }
      })

      if (nextPoints === null) nextPoints = 0

      this.els.nextPoints.element.textContent = `${nextPoints}`
    }

    this.setAttribute('aria-busy', false)
  }

  getRewardValue () {
    const customerPointsBalance = this.customerDetails.pointsBalance

    const customerPointsBalanceRounded =
      Math.floor(customerPointsBalance / 100) * 100

    let foundReward = this.swellConfig.activeRedemptionOptions.at(-1)

    if (customerPointsBalance > foundReward.amount) {
      const foundRewardMult = customerPointsBalanceRounded / foundReward.amount
      return foundReward.discount_amount_cents * foundRewardMult
    } else if (customerPointsBalance <= foundReward.amount) {
      foundReward = this.swellConfig.activeRedemptionOptions.find(
        option => option.amount === customerPointsBalanceRounded,
      )
    }

    if (!foundReward) return 0

    return foundReward.discount_amount_cents
  }

  /* Returns the earliest expiration date of (some) of the customer's points */
  getPointsExpirationDate () {
    const customerPerks = this.swellConfig?.customer?.perks

    if (!customerPerks) return

    let date = null
    customerPerks.forEach(perk => {
      const expirationDate = perk.expiration_date
      if (!expirationDate) return

      const newDate = new Date(expirationDate)

      if (!date || date < newDate) {
        date = newDate
      }
    })
    return date
  }
}

if (!customElements.get('yotpo-customer-details')) {
  customElements.define('yotpo-customer-details', YotpoCustomerDetails)
}
